/**
 * @generated SignedSource<<697d6db9abe91ea1a186b2e0b8a42fd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsInner_slot$data = {
  readonly agenda: {
    readonly facility: {
      readonly club: {
        readonly supportsPublic: boolean;
      } | null | undefined;
      readonly privateBookingPermissionSet: {
        readonly clientCanFulfillRequests: boolean | null | undefined;
      } | null | undefined;
      readonly publicBookingPermissionSet: {
        readonly clientCanFulfillRequests: boolean | null | undefined;
      } | null | undefined;
    };
  };
  readonly " $fragmentType": "NotificationsInner_slot";
};
export type NotificationsInner_slot$key = {
  readonly " $data"?: NotificationsInner_slot$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsInner_slot">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsInner_slot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicBookingPermissionSet",
              "kind": "LinkedField",
              "name": "publicBookingPermissionSet",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PrivateBookingPermissionSet",
              "kind": "LinkedField",
              "name": "privateBookingPermissionSet",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};
})();

(node as any).hash = "162eca75d4a722c60386bb5b5b8a2239";

export default node;
